import { CalendarMonth, Star } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import { useTranslation } from "react-i18next";

export const MonthlyTaxFreeBenefitSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.monthlyTaxFreeBenefit.name",
    type: Subtype.MonthlyTaxFreeBenefitSubtype,
    icon: <Star />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<CalendarMonth />}
        name="actionModules.subtypes.monthlyTaxFreeBenefit.name" />,
    editorPreview: EditorPreview,
    editableProperties: []
};

function EditorPreview() {
    const { t } = useTranslation();
    return <Typography variant="caption">{t("actionModules.subtypes.base.noPreview")}</Typography>;
}